import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-confirmar',
  templateUrl: './modal-confirmar.component.html',
  styleUrls: ['./modal-confirmar.component.scss']
})
export class ModalConfirmarComponent implements OnInit {
  titulo: string;
  mensagem: string;
  aguarde = false;
  autoHide = true;

  constructor(public bsModalRef: BsModalRef) {
    this.titulo = 'Aviso';
  }

  ngOnInit(): void {
    this.adicionaObservadorConfirmarCancelar();
  }

  adicionaObservadorConfirmarCancelar(): void {
    document.addEventListener('keydown', function(e) {
      if(e.key == 'Enter'){
        document.getElementById('confirmar').click();
      }
      if(e.key == 'ESC'){
        document.getElementById('cancelar').click();
      }
    });
  }

  confirmar: () => void ;

  async onConfirmar() {
    this.aguarde = true;
    this.confirmar();
    setTimeout( () => {
      if (this.autoHide) {
        this.bsModalRef.hide();
      }
      this.aguarde = false;
    }, 400);
  }

  hide() {
    this.bsModalRef.hide();
    this.aguarde = false;
  }

  hideModal() {
    if (!this.aguarde) {
      this.bsModalRef.hide();
    }
  }
}
